import script from "./AtlasCategoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./AtlasCategoryView.vue?vue&type=script&setup=true&lang=js"

import "./AtlasCategoryView.vue?vue&type=style&index=0&id=4ab8c430&scoped=true&lang=css"

import exportComponent from "../../../../../../labcheckup/labhub_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ab8c430"]])

export default __exports__